import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ActivatedRoute, Router } from '@angular/router';
import { SingleResultApiResponse, ApiResponse } from 'src/app/shared/models/api-response.model';
import { StorageService } from 'src/app/shared/services/storage.service';
import { ApplicationService } from 'src/app/shared/services/application.service';
import { ErrorResponse } from 'src/app/shared/models/error.model';
import { SupportingDocument, UploadedSupportingDocument, SupportingDocumentScanStatus } from '../models/supporting-document';
import { UUID } from 'angular2-uuid';
import { FormService } from 'src/app/shared/services/form.service';
import { Store } from '@ngrx/store';
import { Action_ApplicationSectionSaved } from '../state/actions';
import { SummaryWithSupportingDocuments } from '../models/summary-with-supporting-documents';
import { interval, Subscription } from 'rxjs';
import { Title } from '@angular/platform-browser';
import { Tab_Title } from 'src/app/shared/models/lookup-data.model';
import { shareReplay } from 'rxjs/operators';
import { SpinnerService } from 'src/app/shared/services/spinner.service';

@Component({
  selector: 'online-app-supporting-documents',
  templateUrl: './supporting-documents.component.html',
  styleUrls: ['./supporting-documents.component.scss'],
  host: {
    class: 'application-section-component'
  },
})
export class SupportingDocumentsComponent implements OnInit {

  // URL = 'http://isponline.det.nsw.edu.au/api/applications';

  selectedHasOtherDocuments: boolean = false;

  uploader: FileUploader;
  applicationId: number;
  documentS3URL = '';
  supportingDocuments: SupportingDocument[] = [];
  otherDocuments: SupportingDocument[] = [];
  supportingDocumentsScanStatus: SupportingDocumentScanStatus[] = [];
  studentNumber = '';
  userFederatedId = '';
  isScrollDone = false;
  isSubmittedApplication = false;
  allowedFileFormats = ['.jpeg', '.jpg', '.pdf', '.doc', '.docx', '.xls', '.xlsx', '.htm', '.tif', '.tiff', '.gif', '.png'];
  showModal = false;
  supportingDocIdToBeDeleted = 0;
  otherDocToBeDeletedIndex = -1;
  summaryWithDocuments: SummaryWithSupportingDocuments;
  carerName = ''
  maxAllowedFileSize = 20.0;
  scanInterval = interval(5000);
  scanIntervalSubscription: Subscription;
  needOtherDocument: boolean = false;

  legalCustodianNames: string;

  @ViewChild('resolve') resolve: ElementRef;
  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private store: Store<any>,
    private formService: FormService,
    private applicationService: ApplicationService,
    private storageService: StorageService,
    private spinnerService: SpinnerService,
    private changeDetectorRef: ChangeDetectorRef,
    private titleService: Title) {
    this.activatedRoute.parent.params.subscribe(params => {
      this.applicationId = +params['id'];
    });

  }

  ngOnInit() {
    if(localStorage.getItem("isAgent") == "true"){
      this.titleService.setTitle(Tab_Title.Agent_SupportingDocuments_Title);
    }else{
      this.titleService.setTitle(Tab_Title.SupportingDocuments_Title);
    }
    this.userFederatedId = localStorage.getItem('identityId');
    this.summaryWithDocuments = this.activatedRoute.snapshot.data['summaryWithDocuments'];

    if (this.summaryWithDocuments && this.summaryWithDocuments.Summary && this.summaryWithDocuments.Summary.Accommodation && this.summaryWithDocuments.Summary.Accommodation.Carers && this.summaryWithDocuments.Summary.Accommodation.Carers.length) {
      const selectedCarer = this.summaryWithDocuments.Summary.Accommodation.Carers.find(c => c.CarerId === this.summaryWithDocuments.Summary.Accommodation.SelectedCarerId)

      if (selectedCarer) {
        this.carerName = `${selectedCarer.GivenName} ${selectedCarer.FamilyName}`;
      }
    }

    if (this.summaryWithDocuments && this.summaryWithDocuments.Summary && this.summaryWithDocuments.Summary.ParentGuardians && this.summaryWithDocuments.Summary.ParentGuardians.length && 
      this.summaryWithDocuments.Summary.ParentGuardians.some(x => x.HasLegalCustody && !x.IsParent)) {
        this.legalCustodianNames = this.summaryWithDocuments.Summary.ParentGuardians.filter(x => x.HasLegalCustody && !x.IsParent).map(y => `${y.GivenName} ${y.FamilyName}`).join(', ');
    }

    if (this.summaryWithDocuments && this.summaryWithDocuments.Summary) {
      this.studentNumber = this.summaryWithDocuments.Summary.StudentNumber;
      this.isSubmittedApplication = this.summaryWithDocuments.Summary.ApplicationStatus === 'Submitted';
    }

    if (this.summaryWithDocuments && this.summaryWithDocuments.SupportingDocuments) {
      this.supportingDocuments = this.summaryWithDocuments.SupportingDocuments.filter(d => d.DocumentTypeCode !== 'Other');
      this.otherDocuments = this.summaryWithDocuments.SupportingDocuments.filter(d => d.DocumentTypeCode === 'Other');
      this.selectedHasOtherDocuments = this.otherDocuments.length > 0;

      this.updateDownloadURLs();
      this.seedOrReseedOtherDocuments();
      this.scanDocumentsWithoutBlocking();
    }
  }

  confirmDeleteDocument() {
    let document = this.supportingDocuments.find(sd => sd.DocumentId === this.supportingDocIdToBeDeleted);

    if (!document)
      document = this.otherDocuments.find(sd => sd.DocumentId === this.supportingDocIdToBeDeleted);

    if (document && document.DocumentId > 0) {
      this.deleteDocument(document);
    }

  }

  dontDeleteDocument() {
    this.supportingDocIdToBeDeleted = 0;
    this.otherDocToBeDeletedIndex = -1;
  }

  print() {
    //console.log('hello');
  }

  previous() {
    this.router.navigate(['/applications', this.applicationId, 'edit', 'special-circumstances']);
  }
  next() {
    this.router.navigate(['/applications', this.applicationId, 'edit', 'summary']);
  }

  deleteDocumentClick(supportingDocument: SupportingDocument, index: number) {
    this.supportingDocIdToBeDeleted = supportingDocument.DocumentId;

    if (supportingDocument.DocumentTypeCode === 'Other') {
      this.otherDocToBeDeletedIndex = index;
    } else {
      this.otherDocToBeDeletedIndex = -1;
    }

    this.showModal = true;
    if (this.supportingDocIdToBeDeleted > 0 && this.showModal) {
      setTimeout(() => {
        this.resolve.nativeElement.focus();
      }, 100);
    }
  }

  displayModal() {
    return this.supportingDocIdToBeDeleted > 0 && this.showModal;
  }

  closeModal() {
    this.showModal = false;
  }

  onFileSelected(event: any) {
    //console.log(event);
    for (const item of this.uploader.queue) {
      //console.log(item);
      item.upload();
    }
  }

  updateDownloadURLs() {
    for (const document of this.supportingDocuments) {

      switch (document.DocumentTypeCode) {
        case 'COVID19ParentDeclarationForm':
          document.DocumentMessage = `Please upload a scanned copy of the duly filled and signed form.`;
          document.FormURL = '/assets/docs/covid-19-parent-declaration.pdf';
          break;
        case 'COVID19ProofOfVaccination':
          document.DocumentMessage = `Evidence of COVID-19 Vaccination of the student. (English translation is required)`;
          document.ExternalLinkText = 'Click here for list of DE International approved vaccines.';
          document.ExternalLinkUrl = 'https://www.deinternational.nsw.edu.au/news/covid-19-information-and-resources';
          break;
        case 'StudentBirthCertificate':
          document.DocumentDescription = 'Student\'s Birth Certificate';
          document.DocumentMessage = `A certified copy of the legal birth certificate of the student.`;
          break;
        case 'StudentPassport':
          document.DocumentDescription = 'Student\'s Passport';
          document.DocumentMessage = `A certified copy of a current and valid passport of the student.`;
          break;
        case 'ParentCarerPassportOrBirthCertificate':
          document.DocumentDescription = `Carer\'s ${this.carerName ? '(' + this.carerName + ') ' : ''}Birth Certificate or Passport`;
          document.DocumentMessage = `A certified copy of the legal birth certificate and/or a copy of a current and valid passport of the carer.`;
          document.Subtext = '(This can be the Guardian\'s Passport, Birth Certificate or Driver\'s License)';
          break;
        case 'LegalCustodianEvidenceOfCourtOrder':
          document.DocumentDescription = `Legal Custodian(s)' ${this.legalCustodianNames ? '(' + this.legalCustodianNames + ') ' : ''} - Evidence of Court Order`;
          document.DocumentMessage = `A certified copy of the court order granting legal custody of the student.`;
          break;
        case 'VisaDecisionRecord':
          document.DocumentDescription = `Carer\'s ${this.carerName ? '(' + this.carerName + ') ' : ''}Visa Desicion Document`;
          document.DocumentMessage = `A copy of the visa refusal decision letter or email for ${this.carerName ? this.carerName : 'the carer'}.`;
          break;
        case 'ParentCarerVisaOrCitizenshipCopy':
          document.DocumentDescription = 'Carer\'s Visa or Citizenship';
          document.DocumentMessage = `This is a copy of the carer’s current and valid visa or citizenship document.`;
          break;
        case 'ParentDeclarationForGuardianVisaApplicantsForm':
          document.DocumentDescription = 'Parent Declaration for Guardian Visa Applicants form';
          document.DocumentMessage = `This document must be complete and signed.`;
          document.FormURL = '/assets/docs/parent-declaration-for-guardian-visa-applicants.pdf';
          break;
        case 'DirectRelativeNominationForm':
          document.DocumentDescription = 'Direct Relative Nomination form';
          document.DocumentMessage = `This document must be complete on all pages and also signed.`;
          document.FormURL = '/assets/docs/direct-relative-nomination-v2.pdf';
          break;
        case 'ParentNominationForm':
          document.DocumentDescription = 'Parent Nomination for Homestay form';
          document.DocumentMessage = `This document must be complete on all pages and also signed.`;
          document.FormURL = '/assets/docs/parent-nomination-for-homestay-v2.pdf';
          break;
        case 'HomestayInformationFormForParents':
          document.DocumentDescription = 'Homestay Information for Parents form';
          document.DocumentMessage = `This document must be signed.`;
          document.FormURL = '/assets/docs/homestay-information-for-parents.pdf';
          break;
        case 'HomestayBookingForm':
          document.DocumentDescription = 'Homestay Booking form';
          document.DocumentMessage = `This document must be complete on all pages and also signed.`;
          document.FormURL = '/assets/docs/homestay-booking-form.pdf';
          break;
        case 'RecommendationLetterOfEnglishTeacher':
          document.DocumentDescription = 'English teacher\'s recommendation letter';
          document.DocumentMessage = `This document must be complete and certified by the school.`;
          document.FormURL = '';
          break;
        case 'AcademicTranscriptForPreviousSchool':
          document.DocumentDescription = 'Student\'s Academic Transcript';
          document.DocumentMessage = `Must include last 24 months of academic results on school letter head. Document must be certified.`;
          document.Subtext = '(This must include the last two years of academic results)';
          break;
        case 'EndOfYearExaminationResults':
          document.DocumentDescription = 'Student\'s Examination Results';
          document.DocumentMessage = `Must include last 24 months of examination results on school letter head. Document must be certified.`;
          document.Subtext = '(This will include the official results of any formal examinations:)';
          break;
        case 'StudentCurrentCOECopy':
          document.DocumentDescription = 'Student\'s Current COE';
          document.DocumentMessage = `This is a copy of the current Confirmation of Enrolment the student is holding.`;
          break;
        case 'StudentCurrentCAAWCopy':
          document.DocumentDescription = 'Student\'s Current CAAW';
          document.DocumentMessage = `This is a copy of the students’ current Confirmation of Appropriate Accommodation and Welfare.`;
          break;
        case 'StudentCurrentOSHCMembershipPolicy':
          document.DocumentDescription = 'Student\'s Current OSHC Membership';
          document.DocumentMessage = `This a copy of the membership confirmation for a current and valid OSHC policy.`;
          break;
        //case 'PersonalDataCollectionAndConsentSupplementForm':
        case 'GDPR Consent Form':
          document.DocumentDescription = 'GDPR Consent Form';
          document.DocumentMessage = `This document must be complete on all pages and also signed.`;
          document.FormURL = '/assets/docs/international-student-program-consent-form.pdf';
          break;
        case 'TermsAndConditions':
          document.DocumentDescription = 'Parent and Student Declaration - Terms and Conditions';
          document.DocumentMessage = `This document must be signed`;
          document.FormURL = '/assets/docs/Parent-Student-Declaration-Terms-conditions.pdf';
          break;
        case 'StudentVisa':
          document.DocumentDescription = `Student's Visa`;
          document.DocumentMessage = `This is a copy of the students’ current and valid visa.`;
          break;
        case 'EnglishLanguageTestResult':
          document.DocumentDescription = `English Language Test Result`;
          document.DocumentMessage = `A certified copy of English Language Test Result`;
        default:
          break;
      }

      if (!document.DownloadURL && document.Status === 'CLEAN') {
        this.storageService.getFile(document.FileKey)
          .subscribe(response => {
            //console.log(`Name:${document.FileName}; Download URL:${response}`);
            document.DownloadURL = response;
          }, errorResponse => {
            document.DownloadURL = null;
          });
      }
    }

  }

  toggleHasOtherDocuments(event) {
    if (this.isSubmittedApplication || this.hasAnUploadedAdditionalDoc) {
      return;
    }
    this.selectedHasOtherDocuments = event.checked;
    this.seedOrReseedOtherDocuments();
  }

  get hasAnUploadedAdditionalDoc() {
    return this.otherDocuments && this.otherDocuments.length && this.otherDocuments.some(d => d.DocumentId > 0);
  }

  seedOrReseedOtherDocuments() {
    if ((this.otherDocuments && this.otherDocuments.some(doc => !doc.DocumentId)) || this.isSubmittedApplication)
      return;

    if (this.selectedHasOtherDocuments && this.otherDocuments.length < 3) {
      const newOtherDoc = new SupportingDocument();
      newOtherDoc.DocumentNote = '';
      newOtherDoc.DocumentTypeCode = "Other";

      this.otherDocuments.push(newOtherDoc);
    }
  }

  getNumberOfDocuments(documents: Document[]): number {
    return (documents !== null && documents !== undefined) ? documents.length : 0;
  }

  getDefaultDocument(supportingDocument: SupportingDocument): Document {
    return new Document();
  }

  downloadDocument(FileKey: string) {
    //console.log('download document clicked');
    this.spinnerService.show();
    this.storageService.getFile(FileKey)
      .subscribe(response => {
        this.spinnerService.hide();
        //console.log('download response from s3');
        //console.log(response);
      }, errorResponse => {
        this.spinnerService.hide();
        //console.log('error downloading document from s3');
        console.log(errorResponse);
      });
  }

  deleteDocument(supportingDocument: SupportingDocument) {
    const documentId = supportingDocument.DocumentId;
    this.spinnerService.show();
    this.applicationService.deleteSupportingDocument(this.applicationId, documentId)
      .subscribe(response => {
        this.spinnerService.hide();
        //console.log('document successfully deleted');
        supportingDocument.FileKey = null;
        supportingDocument.FileName = null;
        supportingDocument.DocumentId = 0;
        this.supportingDocIdToBeDeleted = 0;
        this.dispatchSectionSaveAction();
        if (supportingDocument.DocumentTypeCode === 'Other') {
          this.otherDocuments.splice(this.otherDocToBeDeletedIndex, 1);

          //if (!this.otherDocuments.length) {
          this.seedOrReseedOtherDocuments();
          //}
        }
      },
        errorResponse => {
          this.spinnerService.hide();
          console.log(errorResponse);
        });
  }

  scanDocumentsWithSpinner() {

    this.spinnerService.show();

    this.updateScanStatus$()
      .subscribe((response: ApiResponse) => {
        this.spinnerService.hide();
        if (response && response.Result) {
          this.supportingDocumentsScanStatus = response.Result;

          for (const supportingDocumentScanStatus of this.supportingDocumentsScanStatus) {
            const document = supportingDocumentScanStatus.DocumentTypeId === 19 ?
              this.otherDocuments.find(d => d.DocumentId === supportingDocumentScanStatus.DocumentId)
              :
              this.supportingDocuments.find(d => d.DocumentId === supportingDocumentScanStatus.DocumentId);


            if (document) {
              document.Status = supportingDocumentScanStatus.Status;
              //console.log(`document status:${status}`);
              //console.log(document);
            }

            if (document && document.Status === 'CLEAN') {
              this.storageService.getFile(document.FileKey)
                .subscribe(fileResponse => {
                  document.DownloadURL = fileResponse;
                }, errorResponse => {
                  document.DownloadURL = null;
                });
            }

          }

        }

        this.setOrResetScanDocuments();
      }, (errorResponse: ErrorResponse) => {
        this.spinnerService.hide();
        //console.log('error happened while updating all documents scan status');
        console.log(errorResponse);
      });
  }

  private updateScanStatus$ = () => this.applicationService.updateAllSupportingDocumentsScanStatus(this.applicationId)
                                    .pipe(shareReplay());

  scanDocumentsWithoutBlocking() {
    this.updateScanStatus$()
      .subscribe((response: ApiResponse) => {
        this.spinnerService.hide();
        if (response && response.Result) {
          this.supportingDocumentsScanStatus = response.Result;

          for (const supportingDocumentScanStatus of this.supportingDocumentsScanStatus) {
            const document = supportingDocumentScanStatus.DocumentTypeId === 19 ?
              this.otherDocuments.find(d => d.DocumentId === supportingDocumentScanStatus.DocumentId)
              :
              this.supportingDocuments.find(d => d.DocumentId === supportingDocumentScanStatus.DocumentId);


            if (document) {
              document.Status = supportingDocumentScanStatus.Status;
              //console.log(`document status:${status}`);
              //console.log(document);
            }

            if (document && document.Status === 'CLEAN') {
              this.storageService.getFile(document.FileKey)
                .subscribe(fileResponse => {
                  document.DownloadURL = fileResponse;
                }, errorResponse => {
                  document.DownloadURL = null;
                });
            }

          }

        }

        this.setOrResetScanDocuments();
      }, (errorResponse: ErrorResponse) => {
        this.spinnerService.hide();
        //console.log('error happened while updating all documents scan status');
        console.log(errorResponse);
      });
  }

  scanDocument(supportingDocument: SupportingDocument) {
    const documentId = supportingDocument.DocumentId;
    this.spinnerService.show();
    this.applicationService.updateSupportingDocumentScanStatus(this.applicationId, documentId)
      .subscribe((response: SingleResultApiResponse) => {
        this.spinnerService.hide();
        if (response && response.Result) {
          const status = response.Result;
          const document = this.supportingDocuments.find(d => d.DocumentId === supportingDocument.DocumentId);

          if (document) {
            document.Status = status;
          }

          if (document.Status === 'CLEAN') {
            this.storageService.getFile(document.FileKey)
              .subscribe(fileResponse => {
                document.DownloadURL = fileResponse;
              }, errorResponse => {
                document.DownloadURL = null;
              });
          }


        }

      }, (errorResponse: ErrorResponse) => {
        this.spinnerService.hide();
        //console.log('error happened while updating scan status');
        console.log(errorResponse);
      });
  }

  triggerFileInputClick(event: any, fileInputId: string) {

    if (!event)
      return;

    event.preventDefault();

    let fileInputElem = document.getElementById(fileInputId) as HTMLElement;

    if (!fileInputElem)
      return;

    fileInputElem.click();
  }

  ngAfterContentChecked(): void {
    if (!this.isScrollDone) {
      this.isScrollDone = this.formService.scrollToFirstErrorField();
    }
    this.changeDetectorRef.detectChanges();
  }

  getScanStatus(supportingDocument: SupportingDocument): string {

    const scanStatus = supportingDocument.Status;
    if (!supportingDocument.FileName || !scanStatus) {
      return '';
    }

    let displayScanStatus = 'Not yet scanned';
    
    switch (scanStatus) {
      case 'UPLOADING':
        displayScanStatus = 'Uploading';
        break;
      case 'INITIAL':
        displayScanStatus = 'In Progress';
        break;
      case 'CLEAN':
        displayScanStatus = 'Successful';
        supportingDocument.FileError = '';
        break;
      case 'INFECTED':
        displayScanStatus = 'Virus Found';
        break;
    }
    return displayScanStatus;
  }

  getDocumentName(supportingDocument: SupportingDocument): string {
    return supportingDocument.FileName && supportingDocument.FileName.length > 0
      ? supportingDocument.FileName : 'Please upload a document';
  }

  getDisplayScanStatus(scanStatus: string): string {
    let displayScanStatus = 'Not yet scanned';
    switch (scanStatus) {
      case 'INITIAL':
        displayScanStatus = 'In Progress';
        break;
      case 'CLEAN':
        displayScanStatus = 'Successful';
        break;
      case 'INFECTED':
        displayScanStatus = 'Virus Found';
        break;
    }
    return displayScanStatus;
  }

  fileSelected(event: any, supportingDocument: SupportingDocument) {

    supportingDocument.FileError = '';
    const documentKey = UUID.UUID();

    const { files } = event.target;

    if (files && files.length > 0) {
      const file = files[0];
      const fileSize = ((file.size / 1024) / 1024);

      const fileName: string = file.name;

      const extnIndex = fileName.toLowerCase().lastIndexOf('.');
      const extension = fileName.substr(extnIndex).toLowerCase();
      const fileNameWithoutExtension = fileName.substr(0, extnIndex);

      const isValidExtension = this.allowedFileFormats.find(format => format === extension);

      if (!isValidExtension) {
        supportingDocument.FileError = 'Not a valid file format';
        return;
      }

      if (!(/^[a-zA-Z0-9_-]+$/.test(fileNameWithoutExtension))) {
        supportingDocument.FileError = 'File Name is allowed to contain only alphabets, numbers, dashes and/or underscores';
        return;
      }

      if (fileNameWithoutExtension.length > 100) {
        supportingDocument.FileError = 'File Name can not exceed 100 characters';
        return;
      }

      if (fileSize <= this.maxAllowedFileSize) {

        const key = `${this.studentNumber}/${this.applicationId}/${supportingDocument.DocumentTypeCode}/${documentKey}/${file.name}`;

        const uploadingDocument = supportingDocument.DocumentTypeCode !== 'Other' ?
          this.supportingDocuments.find(d => d.DocumentTypeId === supportingDocument.DocumentTypeId)
          :
          this.otherDocuments[this.otherDocuments.length - 1];

        uploadingDocument.Status = 'UPLOADING';
        this.spinnerService.show();
        this.storageService.uploadFile(key, file, file.type)
          .subscribe((response) => {
            this.spinnerService.hide();
            const uploadedSupportingDocument: UploadedSupportingDocument = {
              DocumentId: supportingDocument.DocumentId || 0,
              DocumentTypeId: supportingDocument.DocumentTypeCode !== 'Other' ? supportingDocument.DocumentTypeId : 19,
              FileKey: key,
              FileName: file.name,
              UserFederatedId: this.userFederatedId,
              DocumentNote: supportingDocument.DocumentNote
            };
            this.spinnerService.show();
            this.applicationService.saveSupportingDocument(this.applicationId, uploadedSupportingDocument)
              .subscribe((saveResponse: SingleResultApiResponse) => {
                this.spinnerService.hide();
                const updatedSupportingDoc = saveResponse.Result as SupportingDocument;

                Object.keys(updatedSupportingDoc).forEach(key => supportingDocument[key] = updatedSupportingDoc[key]);

                this.seedOrReseedOtherDocuments();

                this.setOrResetScanDocuments();
              }, (saveErrorResponse: ErrorResponse) => {
                this.spinnerService.hide();
                const error = saveErrorResponse.errors[0].Value;
                supportingDocument.FileError = error;
              });

          }, (errorResponse) => {
            this.spinnerService.hide();
            console.log(errorResponse);
          });


      } else {
        supportingDocument.FileError = 'File size cannot be more than 20 MB';
      }

      if (supportingDocument.DocumentTypeCode === 'Other') {
        this.seedOrReseedOtherDocuments();
      }

    }

  }

  //refreshes the virus scan status, by calling scan documents after every 5 seconds, but only if subscribed
  setOrResetScanDocuments() {

     if (this.scanIntervalSubscription && this.supportingDocuments.filter(d => d.Status === 'INITIAL').length === 0) {
       this.scanIntervalSubscription.unsubscribe();
     } else if ((!this.scanIntervalSubscription || this.scanIntervalSubscription.closed) && this.supportingDocuments.filter(d => d.Status === 'INITIAL').length > 0) {
       this.scanIntervalSubscription = this.scanInterval.subscribe(val => this.scanDocumentsWithoutBlocking());
     }
  }

  onOtherDocumentSelectClick(event: any, supportingDoc: SupportingDocument) {
    if (supportingDoc.DocumentId) {
      event.stopPropagation();
      return false;
    }

    if (!supportingDoc.DocumentNote)
      supportingDoc.DocumentNote = '';

    //if(!supportingDoc.DocumentNote.trim() || supportingDoc.DocumentNote.length >= 100 ||  supportingDoc.DocumentId) {
    if (!supportingDoc.DocumentNote.trim() || supportingDoc.DocumentId) {
      //console.log('please enter a description for this document');
      supportingDoc.DocumentNoteValidationFailed = true;
      event.stopPropagation();
      return false;
    }
  }

  updateOtherDocumentDescr(event: any, supportingDoc: SupportingDocument) {
    supportingDoc.DocumentMessage = event.target.value
  }

  onKeyUpOtherDocDescr(event: any, supportingDoc: SupportingDocument) {
    supportingDoc.DocumentNoteValidationFailed = false;
  }

  getOtherDocumentDescriptionError(description: string): string {
    let errorMsg = '';
    if (!description) {
      errorMsg = 'Please enter description';
    }
    // else if (description && description.length > 100){
    //   errorMsg = 'Please limit the description length to a maximum of 100 characters';
    // }
    return errorMsg;
  }

  saveAndContinue() {
    this.spinnerService.show();
    this.applicationService.saveSupportingDocuments(this.applicationId)
      .subscribe(response => {
        this.spinnerService.hide();
        this.dispatchSectionSaveAction();
        if(this.selectedHasOtherDocuments && !this.hasAnUploadedAdditionalDoc){
          this.needOtherDocument = true;
          return;
        }else{
          this.needOtherDocument = false;
        }
        this.router.navigate(['/applications', this.applicationId, 'edit', 'summary']);
      }, (errorResponse: ErrorResponse) => {
        this.spinnerService.hide();
        for (const error of errorResponse.errors) {
          const document = this.supportingDocuments.find(d => d.DocumentTypeId === +error.Key);

          if (document) {
            document.FileError = error.Value;
          } else {
            const otherDoc = this.otherDocuments.find(d => d.DocumentNote === error.Key);
            if (otherDoc) {
              otherDoc.FileError = error.Value;
            }
          }
        }

        this.isScrollDone = false;
        if(this.selectedHasOtherDocuments && !this.hasAnUploadedAdditionalDoc){
          this.needOtherDocument = true;
        }else{
          this.needOtherDocument = false;
        }
        this.dispatchSectionSaveAction();
        this.formService.scrollToFirstErrorField();
      });
  }


  dispatchSectionSaveAction() {
    this.store.dispatch({
      type: Action_ApplicationSectionSaved
    });
  }

  //show border when tab on link for accessibility
  linkTabAccessibility(event): void {
    event.style.outline = "1px solid black";
  }

  linkBlurAccessibility(event): void {
    event.style.outline = "";
  }

  /* For accessibility, keyboard only design, use tab to show borders but showing no border by clicking on mouse */
  keyboardFocus(event): void {
    event.style.outline = "1px solid blue";
  }

  keyboardBlur(event): void {
    event.style.outline = "";
  }

  ngOnDestroy() {
      if(this.scanIntervalSubscription){
       this.scanIntervalSubscription.unsubscribe();
      }
  }
}
